import React from 'react';
import { qboBillPaymentUrl, qboBillUrl } from './paymentUtils';

const QboLink = ({ href, label, testid }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
    className="text-blue-600 hover:underline whitespace-nowrap">{label}</a>
);

export const QboRefs = ({ payment }) => (
  <span className="text-xs flex flex-wrap gap-x-2">
    {payment.qbo_bill_id && (
      <QboLink href={qboBillUrl(payment.qbo_bill_id)} label={`Bill ${payment.qbo_bill_id}`}
        testid={`payment-bill-link-${payment.mercury_txn_id}`} />
    )}
    {payment.qbo_bill_payment_id && (
      <QboLink href={qboBillPaymentUrl(payment.qbo_bill_payment_id)} label={`Pmt ${payment.qbo_bill_payment_id}`}
        testid={`payment-bp-link-${payment.mercury_txn_id}`} />
    )}
    {!payment.qbo_bill_id && !payment.qbo_bill_payment_id && <span className="text-slate-400">-</span>}
  </span>
);
